import Vue from 'vue'
import { rolePermissions } from '@/services/config'

export default Vue.extend({
  template: `
    <div>
      <span v-if="!params.data.applicationId">
        <a-tooltip placement="top" title="Edit" v-if="params.edit">
          <a @click="() => editMaster()">
            <i class="fa fa-pencil actionIcon" aria-hidden='true' style="color: #007bff;"/>
          </a>
        </a-tooltip>
        <a-tooltip placement="top" title="Clone" v-if="params.type === 'Tenant Bank' || params.type === 'Grouping Bank'">
          <a @click='() => cloneBank()'>
            <i class='fa fa-clone actionIcon' aria-hidden='true' style='color: #71283e'/>
          </a>
        </a-tooltip>
        <a-tooltip placement="top" title="Delete" v-if="params.delete">
          <a @click="() => deleteMaster()" :disabled="this.params.data.isLinked">
            <i
              class="fa fa-trash-o"
              :disabled="this.params.data.isLinked"
              :class="this.params.data.isLinked ? 'delete' : 'actionIcon'"
              :style="this.params.data.isLinked ? 'color: #b8beca' : 'color: #e03848'"
            />
          </a>
        </a-tooltip>
        <a-tooltip placement="top" title="Save" v-if="params.save && rolePermissions.saveAsGroupingBank.includes(role)">
          <a @click='() => saveAsBank()'>
            <i class='fa fa-save actionIcon' aria-hidden='true' style='color: #007bff'/>
          </a>
        </a-tooltip>
      </span>
    </div>
    `,
  data: function() {
    return {
      value: '',
      role: undefined,
      rolePermissions: rolePermissions,
    }
  },
  beforeMount() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.value = this.params.value
  },
  methods: {
    editMaster() {
      switch (this.params.type) {
        case 'Analysis Type':
          this.$root.$emit('editType', this.params.data.id)
          break
        case 'Asset Class':
          this.$root.$emit('editAssetClass', this.params.data.id)
          break
        case 'Building Use':
          this.$root.$emit('editBuildingUse', this.params.data.id)
          break
        case 'BSUOP':
          this.$root.$emit('editBSUOP', this.params.data.id)
          break
        case 'Category Code':
          this.$root.$emit('editCategoryCode', this.params.data.id)
          break
        case 'Condition Factor':
          this.$root.$emit('editConditionFactor', this.params.data)
          break
        case 'Construction Quality Factor':
          this.$root.$emit('editFactor', this.params.data)
          break
        case 'Contract':
          this.$root.$emit(
            'editContract',
            this.params.data.id,
            this.params.data,
          )
          break
        case 'Grouping Bank':
          this.$router.push(`grouping-bank/${this.params.data.id}`)
          break
        case 'Historical Cost Index':
          this.$root.$emit('editCostIndex', this.params.data.id)
          break
        case 'Interior Grouping':
        case 'Common-Area':
        case 'Interior-Info':
        case 'Site-Takeoff':
          this.$root.$emit('editGrouping', this.params.data)
          break
        case 'Location Factor':
          this.$root.$emit('editLocationFactor', this.params.data.id)
          break
        case 'Structure Profile':
          this.$root.$emit('editProfile', this.params.data.id)
          break
        case 'Takeoff':
          this.$root.$emit('editTakeoff', this.params.data.id)
          break
        case 'Takeoff Grouping':
          this.$root.$emit('editTakeoffGrouping', this.params.data.id)
          break
        case 'Tenant Bank':
          this.$router.push(`tenant-bank/${this.params.data.id}`)
          break
        case 'Tenant Type':
          this.$root.$emit(
            'editTenantType',
            this.params.data.id,
            this.params.data,
          )
          break
        case 'Unit':
          this.$root.$emit('editUnit', this.params.data.id, this.params.data)
          break
        default:
          break
      }
    },
    deleteMaster() {
      switch (this.params.type) {
        case 'Asset Class':
          this.$root.$emit('deleteAssetClass', this.params.data)
          break
        case 'Building Use':
          this.$root.$emit('deleteBuildingUse', this.params.data)
          break
        case 'BSUOP':
          this.$root.$emit('deleteBSUOP', this.params.data)
          break
        case 'Category Code':
          this.$root.$emit('deleteCategoryCode', this.params.data)
          break
        case 'Condition Factor':
          this.$root.$emit('deleteConditionFactor', this.params.data)
          break
        case 'Construction Quality Factor':
          this.$root.$emit('deleteFactor', this.params.data)
          break
        case 'Contract':
          this.$root.$emit('deleteContract', this.params.data)
          break
        case 'Grouping Bank':
          this.$root.$emit('deleteBank', this.params.data)
          break
        case 'Historical Cost Index':
          this.$root.$emit('deleteCostIndex', this.params.data)
          break
        case 'Interior Grouping':
        case 'Common-Area':
        case 'Interior-Info':
        case 'Site-Takeoff':
          this.$root.$emit('deleteGrouping', this.params.data)
          break
        case 'Location Factor':
          this.$root.$emit('deleteLocationFactor', this.params.data)
          break
        case 'Takeoff':
          this.$root.$emit('deleteTakeoff', this.params.data)
          break
        case 'Takeoff Grouping':
          this.$root.$emit('deleteTakeoffGrouping', this.params.data)
          break
        case 'Tenant Bank':
          this.$root.$emit('deleteTenantBank', this.params.data)
          break
        case 'Tenant Type':
          this.$root.$emit('deleteTenantType', this.params.data)
          break
        case 'Unit':
          this.$root.$emit('deleteUnit', this.params.data)
          break
        case 'interiorGrouping':
          this.$root.$emit('deleteInteriorGrouping', this.params.data)
          break
        case 'estimateGroups':
          this.$root.$emit('deleteEstimateGroup', this.params.data)
          break
        default:
          break
      }
    },
    cloneBank() {
      if (this.params.type === 'Tenant Bank') {
        this.$root.$emit('cloneTenantBank', this.params.data)
      } else {
        this.$root.$emit('cloneBank', this.params.data)
      }
    },
    saveAsBank() {
      switch (this.params.type) {
        case 'Common-Area':
        case 'Interior-Info':
        case 'Site-Takeoff':
          this.$root.$emit('saveAsBank', this.params.data)
          break
        case 'interiorGrouping':
          this.$root.$emit('saveAsGrouping', this.params.data)
          break
      }
    },
  },
})
